import React, { Component, Fragment } from 'react'
import classnames from 'classnames'
import connect from 'react-redux/lib/connect/connect';
import { SetPerPage } from '../../common/actions/pageAction';
// import mapStateToProps from 'react-redux/lib/connect/mapStateToProps';

class Pagenation extends Component {
    constructor(props){
        super(props);
        this.state={
            perPage: 5,
        }
    }

    onChange = e => {
        // console.log(e)
        this.props.getPage(Number(e.target.value));
    }

    onPerPage = e => {
        // console.log(e)
        this.props.SetPerPage(Number(e.target.value));
    }

        
    render() {
        const type = this.props.type;
        const { page, totalPage, perPage } = this.props;
        // console.log(page,totalPage)
        const pageIndexCount = 5;
        let leftLimit = Number(page) - Math.floor(pageIndexCount / 2);
        let rightLimit = Number(page) + Math.floor(pageIndexCount / 2);
        if (leftLimit < 1) {
            rightLimit = rightLimit - leftLimit + 1;
            leftLimit = 1;
        }
        if (rightLimit > totalPage) {
            leftLimit -= (rightLimit - totalPage + 1);
            rightLimit = totalPage;
        }
        if (leftLimit < 1) leftLimit = 1;
        let pageIndexes = [];
        for (let i = leftLimit; i <= rightLimit; i++) pageIndexes.push(i);
 
        // console.log(rightLimit,pageIndexes)
 
        return (
 
            <div className="con_box10">
                <div className="page_wrap">
                    {/* <div className="onlyPC" style={{ position: "absolute", left: "calc(50% - 500px)" }}>
                        <select style={{ backgroundColor: "#1c212e", color: "white", width: "50px", height: "43px" }}
                            onChange={this.onPerPage}>
                            <option value={10}>10</option>
                            <option value={15}>15</option>
                            <option value={20}>20</option>
                        </select> &nbsp;개씩 표시
                    </div> */}
                    <ul>
                        <li data-v-4cb00781="" className="btn_first inactive">
                            <span  onClick={(e) => { 
                                e.preventDefault(); 
                                if(Number(page) > 1){
                                    this.props.getPage(1) 
                                }
                                }}className="page">&lt;&lt;</span></li>
                        <li data-v-4cb00781="" className='btn_prev inactive' onClick={(e) => { 
                            e.preventDefault();
                            if(Number(page) > 1){
                                this.props.getPage(Number(page) - 1) 
                            }
                            }
                        }>
                            <span className="page">이전</span></li>
                        {
                            pageIndexes.map(pageIndex => {
                                return (
                                    <li 
                                        data-v-4cb00781=""
                                        href="#"
                                        className={classnames('num', { '': pageIndex === Number(page) })}
                                        onClick={(e) => { e.preventDefault(); this.props.getPage(pageIndex) }}
                                        key={pageIndex} 
                                    >
                                        <span className={classnames('page', { 'pageon': pageIndex === Number(page) })}>
                                            {pageIndex}
                                            </span>
                                    </li>
                                )
                            })
                        }
                        <li data-v-4cb00781="" className='btn_next inactive' onClick={
                            (e) => { 
                                e.preventDefault();
                                if(Number(totalPage) > Number(page)){
                                    this.props.getPage(Math.min(Number(page) + 1, Number(totalPage))) 
                                }
                            }
                            }><span className="page">다음</span></li>
                        <li data-v-4cb00781="" className="btn_last inactive" onClick={
                            (e) => 
                                { 
                                e.preventDefault();
                                if(Number(page) < Number(totalPage)){
                                    this.props.getPage(Number(totalPage)) 
                                }
                            }
                        }><span className="page">&gt;&gt;</span></li>
                    </ul>
                    
                </div>
                {/* <div className="page_wrap onlyMobile" style={{padding: "20px"}}>
                    <select style={{ backgroundColor: "#1c212e", color: "white", width: "50px", height: "30px" }}
                        onChange={this.onPerPage}>
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={15}>15</option>
                        <option value={20}>20</option>
                    </select>개씩 표시
                </div> */}
            </div>
            
        );
    } 
}

const mapStateToProps = state => ({
    pages: state.page,
})

export default connect(mapStateToProps,{ SetPerPage })(Pagenation);



// WEBPACK FOOTER //
// ./src/components/common/Pagenation.js